import type { PropsWithChildren } from 'react';
import { Typography } from '@kizen/kds/Typography';
import styled from '@emotion/styled';
import BackButton from '__components/Button/BackButton';
import {
  contentWidthCss,
  pageSizingCss,
} from 'components/Layout/PageContentWidth';
import { SubNavigationNavBar, SubNavigationNavLink } from './SubNavigation';

type TopNavBackButtonProps = {
  label: string;
  path: string;
  enableRightMargin?: boolean;
};

type TopNavHeaderProps = {
  label: string;
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 20px;
  margin-bottom: 20px;
`;

const Row = styled.div`
  ${pageSizingCss}
  display: flex;
  justify-content: center;
  align-items: center;
`;

const TopNavGrid = styled.div`
  ${contentWidthCss}
  display: grid;
  grid-template-columns: 1fr minmax(0, 1fr) 1fr;
  align-items: center;
  min-height: 36px;
`;

const TopNavRow = ({ children }: PropsWithChildren) => (
  <Row>
    <TopNavGrid>{children}</TopNavGrid>
  </Row>
);

const TopNavLeftContainer = styled.div`
  display: flex;
  align-items: center;
  grid-column: 1;
`;

const TopNavBackButton = (props: TopNavBackButtonProps) => {
  const { label, path, enableRightMargin } = props;

  return (
    <BackButton enableRightMargin={enableRightMargin} to={path}>
      {label}
    </BackButton>
  );
};

const TopNavCenterContainer = styled.div`
  display: flex;
  justify-content: center;
  min-width: 0;
  grid-column: 2;

  > * {
    min-width: 0;
  }
`;

const TopNavRightContainer = styled.div`
  display: flex;
  gap: 15px;
  justify-self: flex-end;
  grid-column: 3;
`;

const TopNavHeader = ({ label }: TopNavHeaderProps) => {
  return (
    <Typography truncate size="2xl" weight="light">
      {label}
    </Typography>
  );
};

export const Nav = {
  Container,
  Row,
  SubNavigationRow: SubNavigationNavBar,
  SubNavigationLink: SubNavigationNavLink,
  TopNavRow,
  TopNavLeftContainer,
  TopNavBackButton,
  TopNavCenterContainer,
  TopNavRightContainer,
  TopNavHeader,
};
